const getSignificantWords = (text: string) => {
  return new Set(
    text
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .split(/\s+/)
      .filter(word => word.length >= 3),
  )
}

export const getReviewImageAltText = ({
  reviewTitle,
  productTitle = '',
}: {
  reviewTitle: string
  productTitle?: string
}) => {
  if (!productTitle) {
    return reviewTitle
  }

  const reviewWords = getSignificantWords(reviewTitle)
  const productTitleWords = getSignificantWords(productTitle)

  const hasCommonWords = [...productTitleWords].some(word => reviewWords.has(word))

  return hasCommonWords ? reviewTitle : `Customer image of ${productTitle}`
}
